import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../../constants/FieldsConst';
import { validMessage } from '../../../../../constants/ValidsFormConst';
import { dateformat, getSumaTimeHelper } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import {
  saveEntHorBloquesAction,
  setActivoEntHorBloquesAction,
} from '../EntHorBloquesAction';

const FormEntHorBloques = ({ isDelete = false }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entHorBloquesStore = Redux.useSelector((state) => state.entHorBloques);

  const activo = isDelete ? null : entHorBloquesStore.activo;

  const initData = {
    nombre: '',
    abrev: '',
    num: 1,
    turno: 0,
    start: entHorariosClasesStore.activo?.start ?? '',
    end: '',
    break: false,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    abrev: false,
    start: false,
    end: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [selectBloque, setSelectBloque] = React.useState(null);

  React.useEffect(() => {
    getDataTimeAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDataTimeAll = () => {
    const num = entHorBloquesStore.all.length;
    if (num > 0) {
      const ult = entHorBloquesStore.all[num - 1];
      setData({
        ...data,
        start: ult.end,
      });
    }
  };

  React.useEffect(() => {
    if (!activo) return;
    setTimeout(
      () =>
        setData({
          nombre: activo.nombre,
          abrev: activo.abrev,
          num: activo.num,
          turno: activo.turno,
          break: activo.break,
          start: activo.start,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      const res = await saveEntHorBloquesAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntHorarioClase: entHorariosClasesStore.activo.id,
        },
        entHorBloquesStore.params,
      );
      if (res) {
        setActivoEntHorBloquesAction(dispatch, null);
        setData({
          ...initData,
          start: data.end,
        });
        setSelectBloque(null);
      }
      setLoadingSave(false);
    }
  };

  function calcularTimeEnd(value) {
    if (data.start) {
      const minutos = entidadesStore.ajustes.minutosAcademicos;
      const time = getSumaTimeHelper(value, minutos);
      _handleSetDataField(CONST.end.name, dateformat(time, { isHHmm: true }));
    }
  }

  function getMenuItem() {
    const items = [];
    for (
      let index = 1;
      index < entHorariosClasesStore.activo.totalBloques;
      index++
    ) {
      const exist = entHorBloquesStore.all.some((el) => el.num === index);
      if (!exist) {
        items.push(
          <MenuItem key={`bloque-item-${index}`} value={index}>
            Bloque {index}
          </MenuItem>,
        );
      }
    }
    return items;
  }

  React.useEffect(() => {
    getDataTimeAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectBloque]);

  React.useEffect(() => {
    calcularTimeEnd(data.start);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.start]);

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          <Stack direction="row" alignItems="center">
            <FormControl fullWidth size="small" required>
              <InputLabel id={`label_select-bloques`}>Bloques</InputLabel>
              <Select
                id="select-bloques"
                value={selectBloque}
                labelId={`label_select-bloques`}
                label="Bloques"
                onChange={(e) => {
                  setSelectBloque(e.target.value);
                  setData({
                    ...data,
                    num: e.target.value,
                    nombre: `Bloque ${e.target.value}`,
                    abrev: `B${e.target.value}`,
                  });
                }}
              >
                {getMenuItem().map((item) => item)}
              </Select>
            </FormControl>
            {selectBloque && (
              <BotonComponent
                icon
                closeIcon
                tooltip="Eliminar"
                ml={1}
                click={() => {
                  setData(initData);
                  setSelectBloque(null);
                }}
              />
            )}
          </Stack>
        </Grid>

        {!selectBloque && (
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              size="small"
              id={CONST.nombre.name}
              required
              label={CONST.nombre.label}
              value={data.nombre}
              onChange={(e) =>
                _handleSetDataField(CONST.nombre.name, e.target.value)
              }
              helperText={dataError.nombre ? validMessage.required : null}
              error={dataError.nombre}
            />
          </Grid>
        )}

        {!selectBloque && (
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              id={CONST.abrev.name}
              required
              label={CONST.abrev.label}
              value={data.abrev}
              onChange={(e) =>
                _handleSetDataField(CONST.abrev.name, e.target.value)
              }
              helperText={dataError.abrev ? validMessage.required : null}
              error={dataError.abrev}
            />
          </Grid>
        )}

        {!selectBloque && (
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              type="number"
              required
              label={CONST.num.label}
              value={Number(data.num)}
              onChange={(e) =>
                _handleSetDataField(CONST.num.name, Number(e.target.value))
              }
              id={CONST.num.name}
              InputProps={{
                inputProps: { min: 1 },
              }}
            />
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="small" required>
            <InputLabel id={`label_${CONST.breaking.name}`}>
              {CONST.breaking.label}
            </InputLabel>
            <Select
              id={CONST.breaking.name}
              value={data.break ? 1 : 0}
              required
              labelId={`label_${CONST.breaking.name}`}
              label={CONST.breaking.label}
              onChange={(e) =>
                _handleSetDataField(
                  CONST.breaking.name,
                  Number(e.target.value) === 1,
                )
              }
            >
              <MenuItem value={1}>SI</MenuItem>
              <MenuItem value={0}>NO</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="small" required>
            <InputLabel id={`label_${CONST.turno.name}`}>
              {CONST.turno.label}
            </InputLabel>
            <Select
              id={CONST.turno.name}
              value={data.turno ? 1 : 0}
              required
              labelId={`label_${CONST.turno.name}`}
              label={CONST.turno.label}
              onChange={(e) =>
                _handleSetDataField(CONST.turno.name, Number(e.target.value))
              }
            >
              <MenuItem value={0}>MAÑANA</MenuItem>
              <MenuItem value={1}>TARDE</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography variant="caption" color="initial">
            <strong>Minutos académicos asignado:</strong>{' '}
            {entidadesStore.ajustes.minutosAcademicos} Minutos
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack direction="row" alignItems="center">
            <TextField
              fullWidth
              size="small"
              type="time"
              id={CONST.start.name}
              required
              label={CONST.start.label}
              value={data.start}
              onChange={(e) =>
                _handleSetDataField(CONST.start.name, e.target.value)
              }
              helperText={dataError.start ? validMessage.required : '07:00'}
              error={dataError.start}
            />
            <BotonComponent
              blue
              icon
              tooltip="Calcular"
              startIcon={<ChevronRightIcon sx={{ color: 'white' }} />}
              ml={1}
              click={() => calcularTimeEnd(data.start)}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="time"
            id={CONST.end.name}
            required
            label={CONST.end.label}
            value={data.end}
            onChange={(e) =>
              _handleSetDataField(CONST.end.name, e.target.value)
            }
            helperText={dataError.end ? validMessage.required : '07:40'}
            error={dataError.end}
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          {entHorBloquesStore.all.length ===
            entHorariosClasesStore.activo.totalBloques &&
          !entHorBloquesStore.activo ? null : (
            <BotonComponent
              click={_handleSubmit}
              text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
              disabled={loadingSave}
              green={!activo}
              blue={activo}
              saveIcon
              mr={2}
            />
          )}
          {entHorBloquesStore.activo && !isDelete && (
            <BotonComponent
              click={() => {
                setActivoEntHorBloquesAction(dispatch, null);
                setData(initData);
              }}
              text="CANCELAR"
              closeIcon
              black
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEntHorBloques;
